export const DETAIL_TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'portfolio', label: 'Portfolio' },
  { id: 'orders', label: 'Orders' },
  { id: 'transactions', label: 'Transactions' },
  { id: 'documents', label: 'Documents' },
  { id: 'account', label: 'Account' },
];
